import { render, staticRenderFns } from "./CheckBoxGroup.vue?vue&type=template&id=26c13474"
import script from "./CheckBoxGroup.vue?vue&type=script&lang=js"
export * from "./CheckBoxGroup.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxGroup.vue?vue&type=style&index=0&id=26c13474&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports